<template>
  <div class="entry">
    <section v-if="!isAgreed && !forceEntry">
      <div class="group container">
        <div class="row"><router-link to="/privacy">「個人情報取得の保護について」</router-link>の内容に同意の上，お申し込みください。</div>
      </div>
    </section>
    <section v-else>
      <keep-alive>
        <router-view />
      </keep-alive>
    </section>
  </div>
</template>

<style lang="scss">
div.entry {
  header {
    margin-bottom: 5.0em;
  }

  footer {
    color: rgb(51, 51, 51);
    margin-top: 2.0em;
    height: 6.0em;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .form-row {
    margin-bottom: 1.0em;
  }

  .bg-primary {
    background-color: #040074!important;
  }

  .group {
    width: 800px;
    margin-bottom: 2.0em;
  }

  div.row {
    margin-top: 1.0em;
    margin-bottom: 1.0em;
  }

  .participant {
    margin-top: 1em;
    margin-left: 0.1em;
    padding: 1.0em;
    border-left: 0.5em solid #040074;
  }

  .add_participant {
    margin-bottom: 2.0em;
    background-color: white;
    color: #007bff;
    padding: 1.0em;
    border: 2px solid #007bff;
    font-weight: bold;
    border-radius: 50px;
  }

  textarea {
    min-width: 20.0rem;
    min-height: 6.0rem;
    max-width: 100%;
  }

  .prev_button, .next_button {
    margin-top: 1.0em;
    margin-bottom: 1.0em;
    padding: 1.0em;
    font-weight: bold;
  }

  .breadcrumb {
    padding: 0;
    background-color: rgb(245, 245, 245);
  }
  .breadcrumb-item+.breadcrumb-item::before {
    content: ">";
  }

  @media screen and (max-width:570px) { 
    .group{
      width: 100%;
    }
  }

  .errorMes {
    margin-top: -1.0em;
    display: none;
    color: red;
    font-size: 0.8em;
  }

  .errorInput {
    border-color: red;
  }

  .maxLengthLabel {
    font-size: 14px;
  }

  .sectionAl {
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
}
</style>

<script>
export default {
  name: 'entry',
  computed: {
    forceEntry() { return this.$store.getters.isForceEntryMode },
    isAgreed() { return this.$store.getters.isAgreed },
    isStorageEnabled() {
      try {
        let info = localStorage.getItem(process.env.VUE_APP_STORAGE_KEY)
        window.console.log(info)
        return true
      } catch(_e) {
        return false
      }
    }
  },
  mounted() {
    //document.getElementById('body').style = "background-color: rgb(245,245,245);"
  },
  beforeDestroy() {
    //document.getElementById('body').style = "background-color: white;"
  }
}
</script>
